import {
    Box,
    Modal,
    Typography,
    TextField,
    Button,
    Container,
    ThemeProvider,
    createTheme,
} from "@mui/material";
import React from "react";
import { ReactComponent as SwyftxLogo } from "../../assets/6385b3d7140115fbf69f92db_SwyftX Logo.svg";
import MessageModal from "../MessageModal";
import PopUpModal from "../PopUpModal";
import { URL, origin } from "../../config";

export default function EditSwyftxLink(props) {
    const [key, setKey] = React.useState("");
    const [error, setError] = React.useState("");
    const [popUpOpen, setPopUpOpen] = React.useState(false);
    const [successOpen, setSuccessOpen] = React.useState(false);

    const theme = createTheme({
        secondary: "#EEEEEE",
        typography: {
            fontFamily: ["Tilt Warp", "sans-serif"].join(","),
        },
    });
    const style = {
        backgroundColor: "whitesmoke",
        top: "50%",
        left: "50%",
        position: "absolute",
        transform: "translate(-50%, -50%)",
        width: "60%",
        boxShadow: 24,
        borderRadius: 2,
        minHeight: "30%",
        "@media (max-width: 75em)": {
            display: "flex",
            flexDirection: "column",
            width: "80%",
            maxHeight: "90vh",
            overflow: "auto",
        },
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        setPopUpOpen(true);
        const data = {
            apiKey: key,
        };
        fetch(`${URL}/link/swyftx`, {
            method: "POST",
            mode: "cors",
            credentials: "include",
            headers: {
                "content-type": "application/json",
                Origin: `${origin}`,
            },
            body: JSON.stringify(data),
        })
            .then((response) => {
                console.log(JSON.stringify(data));
                return response.json();
            })
            .then((data) => {
                if (data.error) {
                    setError(data.error.message);
                    throw new Error(data.error.message);
                }
                setPopUpOpen(false);
                setSuccessOpen(true);
            })
            .catch((err) => {
                console.error(err);
                setPopUpOpen(false);
            });
    };

    const closeMessage = () => {
        setSuccessOpen(false);
        setError("");
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <Modal open={props.open} onClose={props.close}>
                    <Container sx={{ display: "flex" }}>
                        <Box sx={style} display="flex" flexDirection="row">
                            <Box
                                sx={{
                                    background:
                                        "linear-gradient(315deg, #63a4ff 0%, #83eaf1 74%)",
                                    borderRadius: "8px 0 0 8px",
                                    "@media (max-width: 75em)": {
                                        borderRadius: "0",
                                    },
                                }}
                                minWidth="60%"
                                display="flex"
                                flexDirection="column"
                                justifyContent="center"
                            >
                                <Box
                                    display="flex"
                                    flexDirection="column"
                                    alignItems="center"
                                >
                                    <SwyftxLogo
                                        style={{
                                            height: "22px",
                                            width: "80px",
                                            marginLeft: -5,
                                        }}
                                    />
                                    <Typography
                                        sx={{ color: "black" }}
                                        variant="h6"
                                        textAlign="center"
                                    >
                                        Edit Swyftx account key
                                    </Typography>
                                </Box>
                                <Box color="black" sx={{ m: 1, p: 3 }}>
                                    <Typography fontWeight="bold">
                                        Will overwrite existing information
                                    </Typography>
                                    <Typography>- Cannot be undone</Typography>
                                </Box>
                            </Box>
                            <Box
                                display="flex"
                                flexDirection="column"
                                minWidth="40%"
                                alignItems="center"
                                justifyContent="center"
                            >
                                <TextField
                                    error={error ? true : false}
                                    value={key}
                                    onChange={(e) => setKey(e.target.value)}
                                    size="small"
                                    label="API key"
                                    sx={{ width: "90%", my: 1 }}
                                />
                                <Button
                                    disabled={!key}
                                    variant="outlined"
                                    sx={{ m: 1, width: "50%" }}
                                    onClick={handleSubmit}
                                >
                                    Update
                                </Button>
                            </Box>
                        </Box>
                    </Container>
                </Modal>
                <PopUpModal open={popUpOpen} />
                <MessageModal
                    severity="error"
                    title="error"
                    open={error ? true : false}
                    onClose={closeMessage}
                >
                    {error}
                </MessageModal>
                <MessageModal
                    severity="success"
                    title="success"
                    open={successOpen}
                    onClose={closeMessage}
                >
                    Updated swyftx account key
                </MessageModal>
            </ThemeProvider>
        </>
    );
}
